import { employeeCommutingInputsUK } from './regions/UK-employee-commuting.input'
import { employeeCommutingInputsUS } from './regions/US-employee-commuting.input'

export const employeeCommutingMapping: { [key: string]: any } = {
  US: employeeCommutingInputsUS,
  UK: employeeCommutingInputsUK,
}
